<template>
  <div class="result">
    <div class="content">
      <img class="img" :src="image" alt="">
      <span class="imgTxt" v-if="subTxt">{{ subTxt }}</span>
      <slot name="fail" />
      <van-button class="button" type="default" @click="backHomeClick">{{ buttonTxt }}</van-button>
      <div class="view-txt" @click="viewClick" v-if="viewTxt">{{ viewTxt }}</div>
    </div>
  </div>
</template>

<script >

import iconSuccess from '@/assets/img/car-life/icon_complete.png'
import iconFail from '@/assets/img/car-life/icon_fail.png'

export default {

  data() {
    return {
      image: iconSuccess,
    }
  },
  props: {
    result: { 
      type: String,
      required: true
    },
    subTxt: {
      type: String,
      default: ""
    },
    viewTxt: {
      type: String,
      default: ""
    },
    buttonTxt: {
      type: String,
      default: ''
    } 
  },
  computed: {
    
  },
  watch: {
    result: function(val) {
      if(val == 'fail'){
        this.image = iconFail
      }else {
        this.image = iconSuccess
      }
    }
  },
  methods: {
    viewClick() {
      this.$emit("viewClick")
    },
    backHomeClick() {
      this.$emit("backHome")
    }
  }
}

</script>

<style lang="scss" scoped>
.result {
  background-color: #F4F6F7;
  width: 7.5rem;
  min-height: 100vh;
  font-size: 0.32rem;
  color: #383838;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 7.5rem;
    background-color: white;
    min-height: 100vh;
  }

  .img {
    width: 1.80rem;
    height: 1.80rem;
    margin-top: 0.72rem;
    padding-bottom: 0.08rem;
  }

  .imgTxt {
    font-size: 0.48rem;
    color: #383838;
    text-align: center;
  }

  .button {
    margin-top: 0.96rem;
    width: 4.8rem;
    border: 1px solid #B5BABF;
    border-radius: 0.16rem;
  }

  .view-txt {
    margin-top: 0.48rem;
    color: #4D7399;
    text-align: center;
  }
}

</style>